export const CART_ORDER_CURTAIN_LINK = 'order_curtain'
export const RECENTLY_VIEWED_PRODUCTS = 'recentlyViewedProducts'
export const RECENTLY_VIEWED_COORDINATES = 'recentCollections'
export const RECENT_SEARCHES = 'recentSearches'
